const OrderABoxIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_413_8890)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.9504 1.00301C11.9166 1.00704 11.8835 1.01509 11.8517 1.02681L0.262685 5.30932C0.254187 5.31387 0.245689 5.3186 0.237562 5.32385C0.214655 5.33434 0.192672 5.34694 0.172168 5.36129C0.158128 5.37021 0.144458 5.37984 0.131712 5.39034C0.101601 5.41641 0.0757387 5.44668 0.0548646 5.47992C0.0530173 5.48395 0.0511701 5.48815 0.0493227 5.49217C0.0312194 5.52507 0.0182881 5.56006 0.0105296 5.59628C0.0086823 5.60626 0.00738952 5.61623 0.00646589 5.6262C0.00332545 5.64178 0.00110849 5.6577 0 5.67362V18.3265C0.000923635 18.4875 0.105667 18.6319 0.264346 18.6901L0.262683 18.694L11.8517 22.9734C11.9482 23.0089 12.0551 23.0089 12.1516 22.9734L23.7373 18.694C23.8964 18.6348 24.0007 18.4884 24 18.3265V5.67362C23.9991 5.66575 23.998 5.65788 23.9967 5.65C23.9957 5.63513 23.9937 5.62025 23.9909 5.60556C23.9884 5.58928 23.9847 5.57319 23.9797 5.55726C23.9725 5.53627 23.9632 5.51562 23.9523 5.49602C23.9492 5.48937 23.9461 5.48272 23.9425 5.47608C23.9248 5.44773 23.9034 5.42148 23.8788 5.39804C23.8554 5.37634 23.8293 5.35727 23.8012 5.34134C23.794 5.33732 23.7868 5.33347 23.7794 5.3298C23.7658 5.32227 23.7517 5.31527 23.7373 5.30915L19.6291 3.79037L19.5 4L19.3899 3.70236L15.6761 2.32965L15.6754 2.32895L12.1515 1.0268C12.0875 1.00317 12.0186 0.994964 11.9504 1.00301ZM12.0014 1.81141L14.5392 2.7493L4.0903 6.61156L1.55175 5.67366L12.0014 1.81141ZM15.6764 3.16938L18.2643 4.12563L7.90997 8.02216L5.22991 7.03231L15.6764 3.16938ZM19.3966 4.54432L22.4517 5.67344L17.2266 7.60334L12.0014 9.53323L9.04169 8.44L19.3966 4.54432ZM23.1758 6.24546L23.1757 18.0594L12.4142 22.0371V10.2232L23.1758 6.24546ZM0.827667 6.24703L3.82694 7.3555V11.7964C3.82731 11.9576 3.93131 12.1023 4.08944 12.1611L7.1081 13.2779C7.23538 13.3252 7.37928 13.31 7.49215 13.237C7.60521 13.1642 7.673 13.0431 7.67319 12.9136V8.95499L7.91167 8.8654L11.5857 10.2227V22.0357L0.827572 18.0594L0.827667 6.24703ZM4.65542 7.66171L6.90466 8.49232C6.86717 8.55164 6.84647 8.61935 6.84537 8.68847V12.3401L4.65505 11.5271L4.65542 7.66171Z"
                    fill="currentColor"
                    stroke="currentColor"
                    strokeWidth="0.7"
                />
                <g clipPath="url(#clip1_413_8890)">
                    <rect
                        x="13.3008"
                        y="15"
                        width="9"
                        height="9"
                        rx="4.5"
                        fill="white"
                    />
                    <path
                        d="M15.5506 19.1621H15.5461C15.3686 19.1621 15.2246 19.3381 15.2246 19.5559C15.2246 19.7735 15.3683 19.9496 15.5461 19.9496H15.5509H20.0506H20.0551C20.2326 19.9496 20.3766 19.7736 20.3766 19.5559C20.3766 19.3382 20.2329 19.1621 20.0551 19.1621H20.0503H15.5506Z"
                        fill="currentColor"
                    />
                    <path
                        d="M18.2504 17.2499V17.2453C18.2504 17.0679 18.0744 16.9238 17.8566 16.9238C17.639 16.9238 17.4629 17.0675 17.4629 17.2453V17.2501V21.7499V21.7544C17.4629 21.9319 17.6389 22.0759 17.8566 22.0759C18.0743 22.0759 18.2504 21.9322 18.2504 21.7544V21.7496V17.2499Z"
                        fill="currentColor"
                    />
                    <path
                        d="M17.8008 15C15.3192 15 13.3008 17.0187 13.3008 19.5C13.3008 21.9813 15.3195 24 17.8008 24C20.2824 24 22.3008 21.9813 22.3008 19.5C22.3008 17.0187 20.2821 15 17.8008 15ZM17.8008 15.643C19.9351 15.643 21.6582 17.3663 21.6582 19.5004C21.6582 21.6345 19.9352 23.3578 17.8008 23.3578C15.6665 23.3578 13.9434 21.6348 13.9434 19.5004C13.9434 17.3661 15.6663 15.643 17.8008 15.643Z"
                        fill="currentColor"
                        stroke="currentColor"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_413_8890">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
                <clipPath id="clip1_413_8890">
                    <rect
                        x="13.3008"
                        y="15"
                        width="9"
                        height="9"
                        rx="4.5"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
export default OrderABoxIcon;
